import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import updateLocale from "dayjs/plugin/updateLocale";
import localizedFormat from "dayjs/plugin/localizedFormat";
import minMax from "dayjs/plugin/minMax";

dayjs.extend(utc);
dayjs.extend(updateLocale);
dayjs.extend(localizedFormat);
dayjs.extend(minMax);
